import { useForm } from '@inertiajs/react';
import { Button, Input } from '../../../shared/components';
import { LoginLayout } from '../../layouts';

const ConfirmPassword = () => {
    const { data, setData, processing, errors, post } = useForm({
        password: '',
    });

    const handleSubmit = e => {
        e.preventDefault();

        post('/user/confirm-password');
    };

    return (
        <form onSubmit={handleSubmit}>
            <p className='mt-4 mb-11 text-lg'>
                Bevestig je wachtwoord om door te gaan
            </p>
            <Input
                autoFocus={true}
                autoComplete='current-password'
                placeholder='Wachtwoord'
                type='password'
                value={data?.password || ''}
                onChange={e => setData('password', e.target.value)}
                error={errors.password}
            />
            <Button
                content='Bevestigen'
                type='submit'
                disabled={processing}
                loading={processing}
            />
        </form>
    );
};

ConfirmPassword.layout = page => <LoginLayout>{page}</LoginLayout>;

export default ConfirmPassword;
